import api from "./axios";

export const sendMessageApi = async ({ id, message, file }) => {
  const formData = new FormData();
  formData.append("id", id);
  formData.append("message", message || "");
  if (file) formData.append("file", file);

  const { data } = await api.post("/chat/send-message/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  if (!data.success) throw new Error(data.message || "Failed to send message");

  return data.data; // { image_url: ... }
};
